import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

import { BusinessModel, LocationModel, UserBusinessModel } from '@models/index';
import { environment } from '@environments/environment';
import { emptyBusinessModel } from '@utilities/data-utils';
import { businessMock } from '@utilities/function-utils';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  constructor(
    private http: HttpClient
  ) { }

  createBusiness(business: BusinessModel): Observable<BusinessModel> {
    return this.http
      .post<BusinessModel>(`${environment.apiPath}/business`, business).pipe(
        map(business => businessMock(business, 0))
      )
  }

  editBusiness(business: BusinessModel): Observable<BusinessModel> {
    return this.http
      .post<BusinessModel>(`${environment.apiPath}/business/edit`, business).pipe(
        map(business => businessMock(business, 0))
      )
  }

  deleteBusiness(businessId: string): Observable<string> {
    return this.http
      .post(`${environment.apiPath}/business/${businessId}`, {})
      .pipe(
        map(data => data["data"])
      )
  }

  archiveBusiness(businessId: string): Observable<string> {
    return of(businessId)
  }

  searchBusinessLocations(businessId: string): Observable<LocationModel[]> {
    return this.http
      .get<{ total: number, data: LocationModel[] }>(`${environment.apiPath}/locations/business?id=${businessId}`)
      .pipe(
        map(payload => payload.data)
      )
  }

  searchBusinesUsers(businessId: string): Observable<UserBusinessModel[]> {
    return this.http
      .get<UserBusinessModel[]>(`${environment.apiPath}/userBusiness/business?id=${businessId}`)
  }

  searchBusinesByReseller(payload: { page: number, size: number, resellerId: string }): Observable<{ data: BusinessModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/resellers/businesses?id=${payload.resellerId}&page=${payload.page}&size=${payload.size}`)
      .pipe(
        map((items: { data: BusinessModel[], total: number }) => ({
          data: items.data.map(businessMock),
          total: items.total
        }))
      );
  }

  searchBusinessesByQueryByReseller(payload: { page: number, size: number, query: string, resellerId: string }): Observable<{ data: BusinessModel[], total: number }> {
    return this.http
      .get(`${environment.apiPath}/resellers/businesses/autocomplete?page=${payload.page}&size=${payload.size}&query=${payload.query}&id=${payload.resellerId}`)
      .pipe(
        map((items: { data: BusinessModel[], total: number }) => ({
          data: items.data.map(businessMock),
          total: items.total
        })),
      );
  }

  searchBusinessesByUser(userId: string): Observable<BusinessModel[]> {
    return of([{
      name: 'Burger King',
      shortName: 'BK',
      phoneNumber: '123456797',
      zipCode: '124324',
      id: 'bkbkbkbk',
      createdDate: 21312433132,
      updatedDate: 124143432432,
      pinned: true,
      countLocations: 4,
      mainAddress: '3500 S Las Vegas Blvd, Las Vegas, NV 89109, USA',
      countReviews: 74,
      countSentReviewRequests: 247,
      trialMode: false,
      trialStartDate: -1,
      trialEndDate: -1,
    },
    {
      name: 'McDonald\'s',
      shortName: 'McD',
      phoneNumber: '176465374324',
      zipCode: '124324',
      id: 'MCDMCDMCDMCD',
      createdDate: 21312433132,
      updatedDate: 124143432432,
      pinned: false,
      countLocations: 7,
      mainAddress: '1249-1399 Saybrook Ave, East Los Angeles, CA 90022, USA',
      countReviews: 82,
      countSentReviewRequests: 316,
      trialMode: false,
      trialStartDate: -1,
      trialEndDate: -1,
    },
    {
      name: 'Michael Kors',
      shortName: 'PRS',
      phoneNumber: '18652423654567',
      zipCode: '124324',
      id: 'PRSTPRST',
      createdDate: 21312433132,
      updatedDate: 124143432432,
      pinned: true,
      countLocations: 2,
      mainAddress: '657-547 Alexis Cir, Daly City, CA 94014, USA',
      countReviews: 28,
      countSentReviewRequests: 93,
      trialMode: false,
      trialStartDate: -1,
      trialEndDate: -1,
    },
    ])
  }
}
